import styled from 'styled-components'

export const CardContainer = styled.div.attrs({ className: 'card shadow-sm p-4' })`
  align-items: center;
`